import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';

import {BsModalRef} from 'ngx-bootstrap/modal';
import {SessionStorageService} from 'ngx-store';
import {AlertService} from 'ngx-alerts';
import {LoginComponent} from 'app/pages/login/login.component';


import {WsSpa, Funcoes} from '../../../../services';


@Component({
  selector: 'app-alerta-email',
  templateUrl: './alerta-email.component.html',
})
export class AlertaEmailComponent implements OnInit {

  @Output() action = new EventEmitter();


  public bsConfig = {dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-primary', locale: 'br'};
  public usuario;
  public user;
  public page;
  public formEmail: FormGroup;
  public associado;
  public admin;
  public dados;
  public loaders = {
    errorCEL: false, errorTEL: false, errorCPF: false, errorCEP: false,
    errorPAS: false, errorPAA: false, errorASS: false, loadCidades: false, loading: false
  };
  public login : LoginComponent;

  constructor(private formBuilder: FormBuilder,
              private alert: AlertService,
              private wsSpa: WsSpa,
              private funcoes: Funcoes,
              private storage: SessionStorageService,
              public  bsModalRef: BsModalRef) {
    this.admin = (this.storage.get('usuario').tipo === 'G');
  }

    ngOnInit() {
      this.formEmail = this.formBuilder.group({
        email: [null, Validators.required]
        });
      this.user = this.storage.get('usuario');
  }

  public verifyValid(campo) {
    return this.formEmail.controls[campo].errors &&
        (this.formEmail.controls[campo].dirty || this.formEmail.controls[campo].touched)
  }

  public updateEmail() {
    this.loaders.loading = true;
    this.dados = ({
      id: this.usuario.id,
      email: this.formEmail.value.email,
    });

    this.wsSpa.setFunction('update/email', this.dados, 'spaUrl')
        .subscribe(
            data => this.trataRetorno(data),
            error => this.trataErro(error.message)
        )
    let obj = {
        id:         this.user.id,
        nome:       this.user.nome,
        tipo:       this.user.tipo,
        associado:  this.user.associado,
        nome_assoc: this.user.nome_assoc,
        cnpj:       this.user.cnpj,
        email:      this.dados.email,
        telefone:   this.user.telefone,
        faixa:      this.user.faixa,
        uf:         this.user.uf,
        ip:         this.user.ip,
        data_login: this.user.data_login
    };
    this.storage.set('usuario', obj);    
  }
  
  public trataRetorno(retorno) {
    this.loaders.loading = false;
    if (retorno['status'] === 'OK') {
      this.alert.success(retorno.mensagem);
      this.action.emit(true);
      setTimeout(() => {
        this.formEmail.reset();
        this.bsModalRef.hide();
      }, 1000);
    } else {
      this.alert.danger(retorno.mensagem);
    }
  }

  public trataErro(erro) {
    this.loaders.loading = false;
    this.alert.danger(erro)
  }




}
